<h2 mat-dialog-title>{{ isEdit ? 'Editar campo' : 'Nuevo campo' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="field-form">

    <div class="row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Título visible</mat-label>
        <input matInput formControlName="fieldTitle" placeholder="ej: ¿Qué tipo de propiedad es?" />
        <mat-error>El título es requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tipo de campo</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let type of fieldTypes" [value]="type.value">{{ type.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Nombre interno</mat-label>
        <input matInput formControlName="name" placeholder="ej: property_type" />
        <button mat-icon-button matSuffix type="button" matTooltip="Generar desde el título"
                (click)="generateName()">
          <mat-icon>auto_fix_high</mat-icon>
        </button>
        <mat-hint>Minúsculas, números y guión bajo (snake_case)</mat-hint>
        <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
        <mat-error *ngIf="form.get('name')?.hasError('pattern')">Usa snake_case: letras minúsculas, números y _</mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="required" class="required-check">Requerido</mat-checkbox>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Descripción</mat-label>
      <input matInput formControlName="fieldDescription" placeholder="Texto de ayuda que ve el cliente" />
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Rol de UI</mat-label>
        <mat-select formControlName="uiRole">
          <mat-option *ngFor="let role of uiRoles" [value]="role.value">{{ role.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>Distribución (uiGroupHint)</mat-label>
        <mat-select formControlName="uiGroupHint">
          <mat-option *ngFor="let hint of uiGroupHints" [value]="hint.value">{{ hint.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Título en detalle (detailTitle)</mat-label>
        <input matInput formControlName="detailTitle" placeholder="ej: habitaciones" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>Icono en detalle (detailIcon)</mat-label>
        <input matInput formControlName="detailIcon" placeholder="ej: meeting_room" />
        <mat-icon matSuffix>{{ form.get('detailIcon')?.value || 'help_outline' }}</mat-icon>
      </mat-form-field>
    </div>

    <!-- Configuración por tipo -->
    <ng-container *ngIf="isInputType">
      <div class="section-title">Configuración del texto</div>
      <div class="row">
        <mat-form-field appearance="outline" class="grow">
          <mat-label>Placeholder</mat-label>
          <input matInput formControlName="placeholder" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Longitud máxima</mat-label>
          <input matInput type="number" formControlName="maxLength" min="1" />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngIf="isCounter">
      <div class="section-title">Configuración del contador</div>
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Mínimo</mat-label>
          <input matInput type="number" formControlName="counterMin" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Máximo</mat-label>
          <input matInput type="number" formControlName="counterMax" />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngIf="isConfirmation">
      <div class="section-title">Textos de confirmación</div>
      <div class="row">
        <mat-form-field appearance="outline" class="grow">
          <mat-label>Texto afirmativo</mat-label>
          <input matInput formControlName="confirmText" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="grow">
          <mat-label>Texto negativo</mat-label>
          <input matInput formControlName="cancelText" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="grow">
          <mat-label>Texto neutral (opcional)</mat-label>
          <input matInput formControlName="neutralText" />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngIf="isPhotos">
      <div class="section-title">Fotos</div>
      <p class="type-hint">
        Este campo no requiere configuración adicional: el app móvil se encarga de mostrar el
        selector de fotos. Aquí solo defines cómo se identifica y se muestra el campo.
      </p>
    </ng-container>

    <ng-container *ngIf="hasOptions">
      <div class="section-title">
        Opciones
        <button mat-stroked-button color="primary" type="button" (click)="pushOption()">
          <mat-icon>add</mat-icon>
          Agregar opción
        </button>
      </div>
      <div formArrayName="options" class="options-list">
        <div class="option-row" *ngFor="let option of optionsArray.controls; let i = index" [formGroupName]="i">
          <div class="option-image">
            <img *ngIf="optionImages[i]?.imageUrl" [src]="optionImages[i].imageUrl" alt="opción" />
            <mat-icon *ngIf="!optionImages[i]?.imageUrl">image</mat-icon>
          </div>
          <mat-form-field appearance="outline" class="grow">
            <mat-label>Opción {{ i + 1 }}</mat-label>
            <input matInput formControlName="option" />
            <mat-error>El texto de la opción es requerido</mat-error>
          </mat-form-field>
          <button mat-icon-button matTooltip="Subir imagen" type="button" (click)="optionFile.click()">
            <mat-icon>upload</mat-icon>
          </button>
          <input hidden type="file" accept="image/png,image/jpg,image/jpeg,image/webp" #optionFile
                 (change)="onOptionImageSelected($event, i)" />
          <button mat-icon-button matTooltip="Quitar imagen" type="button"
                  *ngIf="optionImages[i]?.imageUrl" (click)="removeOptionImage(i)">
            <mat-icon>hide_image</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Eliminar opción" type="button" (click)="removeOption(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()">Guardar campo</button>
</mat-dialog-actions>
